<app-header></app-header>
  <div class="main-container">
    <div class="container">
      <router-outlet></router-outlet>
    </div>
  </div>
<app-footer></app-footer>

